module.exports = __webpack_public_path__ + "img/project-01-03.ccaf5b8a.png";